export function parsePercent(value) {
  const n = Number(String(value ?? '').replace(/%/g, '').trim());
  return Number.isFinite(n) ? n : null;
}

export function usageTone(pct) {
  if (pct == null) return 'neutral';
  if (pct >= 85) return 'high';
  if (pct >= 70) return 'warn';
  return 'ok';
}

export function formatLoad(host) {
  const parts = [host?.load1, host?.load5, host?.load15].filter((part) => part !== '' && part != null);
  if (!parts.length) return '';
  const cores = host?.cpu ? ` (${host.cpu} CPUs)` : '';
  return `${parts.join(' / ')}${cores}`;
}

export function formatLastSeen(iso) {
  if (!iso) return '';
  const then = new Date(iso);
  if (Number.isNaN(then.getTime())) return '';
  const deltaMs = Date.now() - then.getTime();
  if (deltaMs < 120000) return 'just now';
  return then.toLocaleString();
}

export function disksForHosts(hosts = [], alias = '') {
  const wanted = String(alias || '').toLowerCase();
  return hosts.flatMap((host) =>
    (host.disks || []).map((disk) => ({
      ...disk,
      alias: host.alias,
      checkedAt: disk.checkedAt || host.checkedAt,
    }))
  ).filter((disk) => !wanted || String(disk.alias || '').toLowerCase() === wanted);
}
